module.exports = __webpack_public_path__ + "img/10.ef3dc248.svg";